import _ from "lodash";
import { SEEK } from "constants/widgetTypes";

const generateSeekWidget = (type) => {
  switch (type) {
    case "basic":
      return {
        type: SEEK,
        name: "Seek",
        properties: {
          desktop: {
            visible: true,
            layout: {
              transform: {
                translate: "0px, 211px",
                rotate: "0deg",
              },
              width: "100%",
              height: "auto",
            },
            stretched: false,
            container: {
              minWidth: 1200,
              alignment: "center",
            },
            font: {
              style: null,
              fontSize: "16",
              fontFamily: "Montserrat,sans-serif",
              lineSpacing: null,
              letterSpacing: null,
              color: {
                type: "solid",
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              secondaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
              tertiaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
            },
            margin: 0,
            padding: 16,
            questionDesign: {
              type: "bar",
              bar: {
                backgroundColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                inputFieldColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                placeholderQuestion: "Enter your message",
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1,
                  },
                  width: "1",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                  style: "bottom",
                },
                promptEnabled: false,
                prompts: [
                  "What are your core business values?",
                  "What are the latest industry trends?",
                  "Can you define your competitive advantage?",
                ],
              },
              button: {
                position: null,
                buttonSize: 43,
                verticalOffset: 0,
                horizontalOffset: 0,
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                icon: {
                  iconPadding: 0,
                  iconBackground: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  staticValue: "",
                  media: null,
                  opacity: 1,
                  scale: "1",
                },
              },
            },
            responseDesign: {
              type: "inline",
              backgroundColor: {
                type: "solid",
                r: 245,
                g: 245,
                b: 245,
                a: 1,
              },
              accentColor: {
                type: "solid",
                r: 0,
                g: 189,
                b: 231,
                a: 1,
              },
              processingMessage: "Processing your request...",
              noResultsMessage: "No results found",
            },
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: "0px, 211px",
                rotate: "0deg",
              },
              width: "100%",
              height: "auto",
            },
            stretched: false,
            container: {
              minWidth: 375,
              alignment: null,
            },
            font: {
              style: null,
              fontSize: "16",
              fontFamily: "Montserrat,sans-serif",
              lineSpacing: null,
              letterSpacing: null,
              color: {
                type: "solid",
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              secondaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
              tertiaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
            },
            margin: 0,
            padding: 16,
            questionDesign: {
              type: "bar",
              bar: {
                backgroundColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                inputFieldColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                placeholderQuestion: "Enter your message",
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1,
                  },
                  width: "1",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                  style: "bottom",
                },
                promptEnabled: false,
                prompts: [
                  "What are your core business values?",
                  "What are the latest industry trends?",
                  "Can you define your competitive advantage?",
                ],
              },
              button: {
                position: null,
                buttonSize: 43,
                verticalOffset: 0,
                horizontalOffset: 0,
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                icon: {
                  iconPadding: 0,
                  iconBackground: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  staticValue: "",
                  media: null,
                  opacity: 1,
                  scale: "1",
                },
              },
            },
            responseDesign: {
              type: "popup",
              backgroundColor: {
                type: "solid",
                r: 245,
                g: 245,
                b: 245,
                a: 1,
              },
              accentColor: {
                type: "solid",
                r: 0,
                g: 189,
                b: 231,
                a: 1,
              },
              processingMessage: "Processing your request...",
              noResultsMessage: "No results found",
            },
          },
        },
        widgets: [],
      };

    case "standard":
      return {
        type: SEEK,
        name: "Seek",
        properties: {
          desktop: {
            visible: true,
            layout: {
              transform: {
                translate: "0px, 211px",
                rotate: "0deg",
              },
              width: "100%",
              height: "auto",
            },
            stretched: false,
            container: {
              minWidth: 1200,
              alignment: "center",
            },
            font: {
              style: null,
              fontSize: "16",
              fontFamily: "Montserrat,sans-serif",
              lineSpacing: null,
              letterSpacing: null,
              color: {
                type: "solid",
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              secondaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
              tertiaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
            },
            margin: 0,
            padding: 16,
            questionDesign: {
              type: "bar",
              bar: {
                backgroundColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                inputFieldColor: {
                  type: "solid",
                  r: 245,
                  g: 245,
                  b: 245,
                  a: 1,
                },
                placeholderQuestion: "Seek Content!",
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "50",
                    topRight: "50",
                    bottomLeft: "50",
                    bottomRight: "50",
                  },
                  style: "bottom",
                },
                promptEnabled: false,
                prompts: [
                  "What are your core business values?",
                  "What are the latest industry trends?",
                  "Can you define your competitive advantage?",
                ],
              },
              button: {
                position: null,
                buttonSize: 43,
                verticalOffset: 0,
                horizontalOffset: 0,
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                icon: {
                  iconPadding: 0,
                  iconBackground: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  staticValue: "",
                  media: null,
                  opacity: 1,
                  scale: "1",
                },
              },
            },
            responseDesign: {
              type: "inline",
              backgroundColor: {
                type: "solid",
                r: 255,
                g: 255,
                b: 255,
                a: 1,
              },
              accentColor: {
                type: "solid",
                r: 0,
                g: 189,
                b: 231,
                a: 1,
              },
              processingMessage: "Processing your request...",
              noResultsMessage: "No results found",
            },
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: "0px, 211px",
                rotate: "0deg",
              },
              width: "100%",
              height: "auto",
            },
            stretched: false,
            container: null,
            font: {
              style: null,
              fontSize: "16",
              fontFamily: "Montserrat,sans-serif",
              lineSpacing: null,
              letterSpacing: null,
              color: {
                type: "solid",
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              secondaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
              tertiaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
            },
            margin: 0,
            padding: 16,
            questionDesign: {
              type: "bar",
              bar: {
                backgroundColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                inputFieldColor: {
                  type: "solid",
                  r: 245,
                  g: 245,
                  b: 245,
                  a: 1,
                },
                placeholderQuestion: "Enter your question here",
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "50",
                    topRight: "50",
                    bottomLeft: "50",
                    bottomRight: "50",
                  },
                  style: "none",
                },
                promptEnabled: false,
                prompts: [
                  "What are your core business values?",
                  "What are the latest industry trends?",
                  "Can you define your competitive advantage?",
                ],
              },
              button: {
                position: null,
                buttonSize: 43,
                verticalOffset: 0,
                horizontalOffset: 0,
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                icon: {
                  iconPadding: 0,
                  iconBackground: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  staticValue: "",
                  media: null,
                  opacity: 1,
                  scale: "1",
                },
              },
            },
            responseDesign: {
              type: "popup",
              backgroundColor: {
                type: "solid",
                r: 245,
                g: 245,
                b: 245,
                a: 1,
              },
              accentColor: {
                type: "solid",
                r: 0,
                g: 189,
                b: 231,
                a: 1,
              },
              processingMessage: "Processing your request...",
              noResultsMessage: "No results found",
            },
          },
        },
        widgets: [],
      };

    case "mordern":
      return {
        type: SEEK,
        name: "Seek",
        properties: {
          desktop: {
            visible: true,
            layout: {
              transform: {
                translate: "0px,33px",
                rotate: "0deg",
                scale: "1,1",
              },
              width: "100%",
              height: "auto",
            },
            stretched: false,
            container: {
              minWidth: 1200,
              alignment: "center",
            },
            font: {
              style: null,
              fontSize: "16",
              fontFamily: "Montserrat,sans-serif",
              lineSpacing: null,
              letterSpacing: null,
              color: {
                type: "solid",
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              secondaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
              tertiaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
            },
            margin: 0,
            padding: 16,
            questionDesign: {
              type: "bar",
              bar: {
                backgroundColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                inputFieldColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                placeholderQuestion: "Enter your question here",
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1,
                  },
                  width: "2",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                  style: "bottom",
                },
                promptEnabled: true,
                prompts: [
                  "What are your core business values?",
                  "What are the latest industry trends?",
                  "Can you define your competitive advantage?",
                ],
              },
              button: {
                position: null,
                buttonSize: 43,
                verticalOffset: 0,
                horizontalOffset: 0,
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                icon: {
                  iconPadding: 0,
                  iconBackground: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  staticValue: "",
                  media: null,
                  opacity: 1,
                  scale: "1",
                },
              },
            },
            responseDesign: {
              type: "inline",
              backgroundColor: {
                type: "solid",
                r: 245,
                g: 245,
                b: 245,
                a: 1,
              },
              accentColor: {
                type: "solid",
                r: 0,
                g: 189,
                b: 231,
                a: 1,
              },
              processingMessage: "Processing your request...",
              noResultsMessage: "No results found",
            },
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: "0px, 211px",
                rotate: "0deg",
              },
              width: "100%",
              height: "auto",
            },
            stretched: false,
            container: null,
            font: {
              style: null,
              fontSize: "16",
              fontFamily: "Montserrat,sans-serif",
              lineSpacing: null,
              letterSpacing: null,
              color: {
                type: "solid",
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              secondaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
              tertiaryColor: {
                type: "solid",
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
            },
            margin: 0,
            padding: 16,
            questionDesign: {
              type: "bar",
              bar: {
                backgroundColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                inputFieldColor: {
                  type: "solid",
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                placeholderQuestion: "Enter your question here",
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1,
                  },
                  width: "1",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                  style: "bottom",
                },
                promptEnabled: true,
                prompts: [
                  "What are your core business values?",
                  "What are the latest industry trends?",
                  "Can you define your competitive advantage?",
                ],
              },
              button: {
                position: null,
                buttonSize: 43,
                verticalOffset: 0,
                horizontalOffset: 0,
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                icon: {
                  iconPadding: 0,
                  iconBackground: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  staticValue: "",
                  media: null,
                  opacity: 1,
                  scale: "1",
                },
              },
            },
            responseDesign: {
              type: "popup",
              backgroundColor: {
                type: "solid",
                r: 245,
                g: 245,
                b: 245,
                a: 1,
              },
              accentColor: {
                type: "solid",
                r: 0,
                g: 189,
                b: 231,
                a: 1,
              },
              processingMessage: "Processing your request...",
              noResultsMessage: "No results found",
            },
          },
        },
        widgets: [],
      };

    case "basic_icon":
      return {
        type: SEEK,
        name: "Seek",
        properties: {
          desktop: {
            visible: true,
            layout: {
              transform: {
                translate: `1230px, 80px`,
                rotate: "0deg",
              },
              width: "43px",
              height: "43px",
            },
            container: {
              alignment: "center",
              minWidth: 1200,
            },
            visible: true,
            stretched: false,
            padding: 0,
            fontStyles: {
              fontSize: "16",
              fontStyle: "normal",
              fontFamily: "Montserrat,sans-serif",
              primaryColor: {
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              secondaryColor: {
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
            },
            questionDesign: {
              type: "button",
              bar: {
                backgroundColor: {
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                inputFieldColor: {
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                placeholderQuestion: "Enter your question here",
                border: {
                  color: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: 0,
                  radius: {
                    locked: true,
                    topLeft: 0,
                    topRight: 0,
                    bottomLeft: 0,
                    bottomRight: 0,
                  },
                },
                promptEnabled: false,
                prompts: [
                  "What are your core business values?",
                  "What are the latest industry trends?",
                  "Can you define your competitive advantage?",
                ],
              },
              button: {
                position: "topRight",
                buttonSize: 43,
                verticalOffset: 0,
                horizontalOffset: 0,
                border: {
                  color: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: 0,
                  radius: {
                    locked: true,
                    topLeft: 0,
                    topRight: 0,
                    bottomLeft: 0,
                    bottomRight: 0,
                  },
                },
                icon: {
                  iconPadding: 0,
                  iconBackground: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  staticValue: "",
                  media: {},
                  opacity: 1,
                  scale: "1",
                },
              },
            },
            responseDesign: {
              type: "inline",
              backgroundColor: {
                r: 245,
                g: 245,
                b: 245,
                a: 1,
              },
              accentColor: {
                r: 5,
                g: 115,
                b: 174,
                a: 1,
              },
              logo: null,
              processingMessage: "Processing your request...",
              noResultsMessage: "No results found",
            },
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: `0px, 0px`,
                rotate: "0deg",
              },
              width: "100%",
              height: "50px",
            },
            padding: 0,
            fontStyles: {
              fontSize: "16",
              fontStyle: "normal",
              fontFamily: "Montserrat,sans-serif",
              primaryColor: {
                r: 0,
                g: 0,
                b: 0,
                a: 1,
              },
              secondaryColor: {
                r: 111,
                g: 111,
                b: 111,
                a: 1,
              },
            },
            questionDesign: {
              type: "button",
              bar: {
                backgroundColor: {
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                inputFieldColor: {
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1,
                },
                placeholderQuestion: "Enter your question here",
                border: {
                  color: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: 0,
                  radius: {
                    locked: true,
                    topLeft: 0,
                    topRight: 0,
                    bottomLeft: 0,
                    bottomRight: 0,
                  },
                },
                promptEnabled: false,
                prompts: [
                  "What are your core business values?",
                  "What are the latest industry trends?",
                  "Can you define your competitive advantage?",
                ],
              },
              button: {
                position: "topRight",
                buttonSize: 43,
                verticalOffset: 0,
                horizontalOffset: 0,
                border: {
                  color: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: 0,
                  radius: {
                    locked: true,
                    topLeft: 0,
                    topRight: 0,
                    bottomLeft: 0,
                    bottomRight: 0,
                  },
                },
                icon: {
                  iconPadding: 0,
                  iconBackground: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  staticValue: "",
                  media: {},
                  opacity: 1,
                  scale: "1",
                },
              },
            },
            responseDesign: {
              type: "inline",
              backgroundColor: {
                r: 245,
                g: 245,
                b: 245,
                a: 1,
              },
              accentColor: {
                r: 5,
                g: 115,
                b: 174,
                a: 1,
              },
              logo: null,
              processingMessage: "Processing your request...",
              noResultsMessage: "No results found",
            },
          },
        },
        widgets: [],
      };

    default:
      break;
  }
};

export const seekBars = [
  {
    id: "seek_bar_1",
    name: "Seek Bar 1",
    type: "bar",
    render: () => {
      return <img src="/images/palette/seek/seekBars/bar1.png" />;
    },
    data: generateSeekWidget("basic"),
  },
  {
    id: "seek_bar_2",
    name: "Seek Bar 2",
    type: "bar",
    render: () => {
      return <img src="/images/palette/seek/seekBars/bar2.png" />;
    },
    data: generateSeekWidget("standard"),
  },
  {
    id: "seek_bar_3",
    name: "Seek Bar 3",
    type: "bar",
    render: () => {
      return <img src="/images/palette/seek/seekBars/bar3.png" />;
    },
    data: generateSeekWidget("mordern"),
  },
];

export const seekButtons = [
  {
    id: "seek_button_1",
    name: "Seek Button 1",
    type: "button",
    render: () => {
      return <img src="/images/palette/seek/seekButtons/button1.png" />;
    },
    data: generateSeekWidget("basic_icon"),
  },
  {
    id: "seek_button_2",
    name: "Seek Button 2",
    type: "button",
    render: () => {
      return <img src="/images/palette/seek/seekButtons/button2.png" />;
    },
    data: generateSeekWidget("mordern_icon"),
  },
  {
    id: "seek_button_3",
    name: "Seek Button 3",
    type: "button",
    render: () => {
      return <img src="/images/palette/seek/seekButtons/button3.png" />;
    },
    data: generateSeekWidget("standard_icon"),
  },
];
